import TranslatedSpan from './TranslatedSpan';

export const TermsAndConditions = () => {
    return <>
        <p>
            <TranslatedSpan english="accessing_government_info_by_login"/>
        </p>
        <ul>
            <li>
                <TranslatedSpan english="information_about_authorised_user" />
            </li>
            <li>
                <TranslatedSpan english="your_visit_may_be_recorded" />
            </li>
            <li>
                <TranslatedSpan english="if_you_access_someones_info" />
            </li>
        </ul>
    </>;
};